/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Sttitle1Inputs */

const zh_landing_admin_sttitle1 = /** @type {(inputs: Landing_Admin_Sttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为学生真实的学习方式而设计`)
};

const en_landing_admin_sttitle1 = /** @type {(inputs: Landing_Admin_Sttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built for How Students Actually Learn`)
};

const es_landing_admin_sttitle1 = /** @type {(inputs: Landing_Admin_Sttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensado para cómo aprenden realmente los estudiantes`)
};

/**
* | output |
* | --- |
* | "Built for How Students Actually Learn" |
*
* @param {Landing_Admin_Sttitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_sttitle1 = /** @type {((inputs?: Landing_Admin_Sttitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Sttitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_sttitle1(inputs)
	if (locale === "en") return en_landing_admin_sttitle1(inputs)
	return es_landing_admin_sttitle1(inputs)
});
export { landing_admin_sttitle1 as "landing_admin_stTitle" }